const ITEM_SELECTOR = '.flyout__item, .flyout-mobile__item, .flyout-menu__level2 a';

function normalizePath(path: string): string {
    return path.replace(/\/+$/, '') || '/';
}

function isOnPathOf(itemPath: string, currentPath: string): boolean {
    // The homepage is an ancestor of every page, so it only counts as an exact match
    if (itemPath === '/') return currentPath === '/';
    return currentPath === itemPath || currentPath.startsWith(itemPath + '/');
}

export function initNavigationActiveState(): void {
    const currentPath = normalizePath(window.location.pathname);

    document.querySelectorAll<HTMLElement>(ITEM_SELECTOR).forEach((item) => {
        const uri = item.getAttribute('href') ?? item.dataset.uri;
        if (!uri) return;

        const url = new URL(uri, window.location.href);
        if (url.origin !== window.location.origin) return;

        const itemPath = normalizePath(url.pathname);
        if (!isOnPathOf(itemPath, currentPath)) return;

        item.classList.add('active');
        if (itemPath === currentPath && item.tagName === 'A') {
            item.setAttribute('aria-current', 'page');
        }
    });

    document.querySelectorAll<HTMLElement>('.flyout__item[aria-controls], .flyout-mobile__item[aria-controls]').forEach((trigger) => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (panel?.querySelector('.flyout-menu__level2 a.active')) {
            trigger.classList.add('active');
        }
    });
}
